export default "__VITE_ASSET__7WeAIxEA__"